<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.configurations'), disabled: true },
        { title: this.$t('menu.users'), disabled: true }
      ]">
      <span slot="breadcrumbAfter" class="d-flex">
        <Searchable
          :querySearch.sync="querySearch"
        />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilterCount"
          @toggle-filters="toggleFilters"
        />
      </span>
    </Breadcrumbs>

    <div class="btn btn__floating btn__round__large" v-if="hasWriteUsersPermissions">
      <va-popover :message="$t('users.create_user')">
        <va-button
          @click.prevent="createUser"
        >
          <i class="fa fa-plus"></i>
        </va-button>
      </va-popover>
    </div>

    <UsersTable v-if="!localStorageExists()|| Object.keys(customQueries).length > 0"
      ref="usersTable"
      :customQueries="customQueries"
      :querySearch="querySearch"
      :showFilters="showFilters"
      :tableName="'usersTable'"
      @filters-updated="onFiltersUpdated"
    />

    <assign-roles-modal
      v-if="userWasRecentlyCreated"
      v-bind="assignRolesProps"
      @cancel="assignRolesModalClosed">
    </assign-roles-modal>

    <CreateOrUpdateUser
      v-if="hasWriteUsersPermissions && isCreatingUser"
      @user-created="onUserCreated"
      @cancel="cancelCreateUser"
    />

  </div>
</template>

<script>
import Searchable from '@/components/common/Searchable'
import Filters from '@/components/common/Filters'
import UsersTable from '@/components/users/UsersTable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import AssignRolesModal from '@/components/users/components/Roles/AssignRolesModal'
import CreateOrUpdateUser from '@/components/users/components/CreateOrUpdateUser'
import IndexTablesMixin from '@/mixins/IndexTablesMixin';
import {TABLE_LICENSE_KIOSKS, TABLE_USERS} from '@/local-storage/LocalStorageKeys';
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";

const usersInfoType = 100
const writeAccessType = 2

export default {
  mixins: [
    IndexTablesMixin
  ],
  components: {
    Searchable,
    Filters,
    Breadcrumbs,
    UsersTable,
    AssignRolesModal,
    CreateOrUpdateUser
  },
  props: {
    audiology_server: {
      type: String,
      required: false
    }
  },
  mounted: function() {
    if(this.customQueries && this.customQueries.entity) {
      this.showFilters = true
    }
  },
  data () {
    return {
      querySearch: '',
      isCreatingUser: false,
      showFilters: false,
      userWasRecentlyCreated: false,
      assignRolesProps: {},
      activeFilterCount: 0,
      customQueries: {},
      localStorageKey: TABLE_USERS
    }
  },
  computed: {
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    },
    hasWriteUsersPermissions: function () {
      return this.authService && this.authService.user_permissions.some(p => p.info_type === usersInfoType && p.access_type >= writeAccessType)
    }
  },
  methods: {
    localStorageExists: function () {
      return LocalStorageHelper.hasKey(TABLE_USERS)
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    createUser: function () {
      this.isCreatingUser = true
    },
    onUserCreated: function ({ user }) {
      this.userWasRecentlyCreated = true
      this.assignRolesProps.newUser = user
      this.$refs.usersTable.refresh()
    },
    assignRolesModalClosed: function () {
      this.userWasRecentlyCreated = false
      this.assignRolesProps = {}
    },
    cancelCreateUser: function () {
      this.isCreatingUser = false
    },
    onFiltersUpdated: function ({ filters, count }) {
      this.activeFilterCount = count
    }
  }
}
</script>
